export function scrollTo(options) {
    // To always load the page scrolled on the top
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    setTimeout(() => {
        window.scrollTo(options);
    }, 0);
}
export function removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
}
export function isIOS() {
    return (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
    // eslint-disable-next-line @typescript-eslint/comma-dangle
    navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document));
}
export function trackEvent(name, category, label, value) {
    if (typeof window.gtag !== 'undefined') {
        gtag('event', name, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
}
export function trackViewSection(section) {
    if (typeof window.gtag !== 'undefined') {
        gtag('event', `scroll_at_${section}`, {
            event_category: 'engagement',
            event_label: section,
        });
    }
}
